import toast, { ToastOptions } from 'react-hot-toast';

const defaultOptions: ToastOptions = {
  duration: 3000,
  position: 'top-right',
};

const successOptions: ToastOptions = {
  ...defaultOptions,
  style: {
    background: 'linear-gradient(to right, #4ade80, #22c55e)',
    color: 'white',
  },
  icon: '✅',
};

const errorOptions: ToastOptions = {
  ...defaultOptions,
  style: {
    background: 'linear-gradient(to right, #ef4444, #dc2626)',
    color: 'white',
  },
  icon: '❌',
};

const warningOptions: ToastOptions = {
  ...defaultOptions,
  style: {
    background: 'linear-gradient(to right, #f59e0b, #d97706)',
    color: 'white',
  },
  icon: '⚠️',
};

export const showToast = {
  success: (message: string) => toast.success(message, successOptions),
  error: (message: string) => toast.error(message, errorOptions),
  warning: (message: string) => toast(message, warningOptions),
};